import React from 'react';
import { formatDataOra } from '../utils/formatSistema';

export interface VerificaIntegrazione {
  id: number;
  origine: string;
  esitoOk: boolean;
  messaggio: string | null;
  durataMs: number | null;
  createdAt: string;
}

export const ORIGINE_LABEL: Record<string, string> = {
  MANUALE: 'Verifica manuale',
  KEEPALIVE: 'Verifica notturna',
  UTILIZZO: 'Utilizzo',
  VERIFICA: 'Verifica credenziali',
};

// Il gateway OCPP non è verificato dal keepalive notturno: manda lui un segnale
// ogni 15 minuti, che il registro salva con la stessa origine KEEPALIVE
const ORIGINE_LABEL_GATEWAY: Record<string, string> = {
  ...ORIGINE_LABEL,
  KEEPALIVE: 'Segnale del gateway',
};

interface Props {
  verifiche: VerificaIntegrazione[];
  /** Tipo di integrazione (es. OCPP_GATEWAY): cambia l'etichetta dell'origine KEEPALIVE */
  tipo?: string;
}

/** Ultimi accessi a un'integrazione (verifiche manuali, notturne, utilizzo reale). */
export default function StoricoVerificheIntegrazione({ verifiche, tipo }: Props) {
  const etichette = tipo === 'OCPP_GATEWAY' ? ORIGINE_LABEL_GATEWAY : ORIGINE_LABEL;
  return (
    <div className="bop-card">
      <div className="bop-card__header">
        <h3 className="bop-card__title">Ultimi accessi</h3>
      </div>
      {verifiche.length === 0 ? (
        <div className="bop-empty-state">
          <p className="bop-empty-state__title">Nessun accesso registrato</p>
          {tipo === 'OCPP_GATEWAY' ? (
            <p>Il gateway manda un segnale ogni 15 minuti.</p>
          ) : (
            <p>La verifica notturna gira ogni giorno alle 06:00; puoi anche verificare subito con il pulsante qui sopra.</p>
          )}
        </div>
      ) : (
        <div className="bop-table-wrapper">
          <table className="bop-table">
            <thead>
              <tr>
                <th>Data</th>
                <th>Origine</th>
                <th>Esito</th>
                <th>Dettaglio</th>
                <th className="bop-integrazione__col-num">Durata</th>
              </tr>
            </thead>
            <tbody>
              {verifiche.map(v => (
                <tr key={v.id}>
                  <td>{formatDataOra(v.createdAt)}</td>
                  <td>{etichette[v.origine] || v.origine}</td>
                  <td>
                    <span className={`bop-badge ${v.esitoOk ? 'bop-badge--success' : 'bop-badge--danger'}`}>
                      {v.esitoOk ? 'OK' : 'Errore'}
                    </span>
                  </td>
                  <td className="bop-integrazione__messaggio">{v.messaggio || '—'}</td>
                  <td className="bop-integrazione__col-num">{v.durataMs !== null ? `${v.durataMs} ms` : '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
